import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';
import { IStateService } from 'angular-ui-router';

angular.module('flowingly.runner.library').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state('app.runner.library.procedures', {
    url: '/sops',
    params: { title: 'Library -  SOPs' },
    views: {
      childcontent: {
        controllerAs: '$ctrl',
        controller: [
          'APP_CONFIG',
          '$state',
          function (
            APP_CONFIG: SharedAngular.APP_CONFIG,
            $state: IStateService
          ) {
            if (!APP_CONFIG.enableProcedures) {
              $state.go('app.runner.library');
            }
          }
        ],
        template:
          '<flow-library-tabs-procedures></flow-library-tabs-procedures>'
      }
    }
  });
}
